import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
  Renderer2,
} from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[mdwTwoDigitNumber]',
})
export class MdwTwoDigitNumber implements AfterViewInit {
  private el = inject<ElementRef<HTMLInputElement>>(ElementRef);
  private renderer = inject(Renderer2);
  private ngControl = inject(NgControl, { self: true });

  public padSingleDigits = input<boolean>(false);
  public maxValue = input<number>();

  public ngAfterViewInit(): void {
    setTimeout(() => {
      // Get the initial value of the input
      let initialValue: number | string =
        this.ngControl?.control?.value || this.el.nativeElement.value;

      if (initialValue === undefined) {
        return;
      }

      if (typeof initialValue === 'string') {
        initialValue = parseInt(initialValue, 10);
      }

      // If the value is a single digit, pad it to two digits
      if (initialValue && initialValue < 10 && this.padSingleDigits()) {
        const formattedValue = '0' + initialValue;

        // Update the input element's value
        this.renderer.setProperty(this.el.nativeElement, 'value', formattedValue);
      }
    });
  }

  @HostListener('input')
  public onInput() {
    const value = this.el.nativeElement.value;
    const position = this.el.nativeElement.selectionStart || 0;
    const maxValue = this.maxValue() || 99;

    // Limit input to two characters
    const filteredValue = value.replace(/[^0-9]/g, '').substring(0, 2);
    const parsedValue = parseInt(filteredValue, 10);

    let newValue = isNaN(parsedValue) ? '' : Math.min(parsedValue, maxValue).toString();
    const startsWithZero = filteredValue.startsWith('0');
    if (startsWithZero) {
      newValue = `0${newValue}`;
    }

    // Update the input element value
    this.renderer.setProperty(this.el.nativeElement, 'value', newValue);

    // Synchronize the FormControl value
    if (this.ngControl && this.ngControl.control) {
      this.ngControl.control.setValue(newValue);
    }

    const newPosition = Math.min(position, newValue.length);

    // Set the cursor position
    this.el.nativeElement.setSelectionRange(newPosition, newPosition);
  }

  @HostListener('blur')
  public onBlur() {
    let value = this.el.nativeElement.value;

    // Pad single digits with a leading zero
    if (this.padSingleDigits() && value.length === 1) {
      value = `0${value}`;

      // Update the input element value
      this.renderer.setProperty(this.el.nativeElement, 'value', value);
    }
  }
}
